export function logHttpError(serviceName: string, context: string, resp: any, metadata?: Record<string, any>): void {
  console.error(`[${serviceName}] ${context}`, {
    status: resp?.status ?? resp?.error?.errorCode,
    url: resp?.url,
    message: resp?.message,
    error: resp?.error,
    ...(metadata || {})
  });
}
